
import Vue from 'vue'
import ContentEditor from '@/components/shared/ContentEditor'
import ContentField from '@/components/shared/ContentField'

Vue.component('content-editor', ContentEditor)
Vue.component('content-field', ContentField)



// WEBPACK FOOTER //
// ./src/modules/global-components.js